<template lang="html">
  <v-div class="pagination-controls">
    <v-button @click="onPaginationChange(Math.max(1, currentPage - 1))">
      <i class="icon-arrow-left"></i>
    </v-button>
    <v-button
      v-for="page in totalPages"
      :key="page"
      @click="onPaginationChange(page)"
      :class="{
        active: currentPage === page,
      }"
    >
      {{ page }}
    </v-button>
    <v-button
      @click="onPaginationChange(Math.min(totalPages, currentPage + 1))"
    >
      <i class="icon-arrow-right"></i>
    </v-button>
  </v-div>
</template>
<script>
export default {
  props: {
    totalPages: Number,
    loadPage: Function,
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  methods: {
    onPaginationChange(currentPage) {
      this.currentPage = currentPage;
      this.loadPage(currentPage);
    },
  },
};
</script>
<style lang="scss">
.pagination-controls {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.pagination-controls button {
  margin: 0 5px;
  padding: 5px 10px;
  border: 1px solid #ccc;
  background-color: #fff !important;
  color: grey;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s;
}

.pagination-controls button.active {
  background-color: #007bff !important;
  color: #fff;
  border-color: #007bff;
}

.pagination-controls button:hover {
  background-color: #f2f2f2;
  color: #007bff;
  border-color: #007bff;
}
</style>



// WEBPACK FOOTER //
// src/parts/components/pagination.vue